import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RejectPopupComponent } from 'src/app/popups/reject-popup/reject-popup.component';
import { AcceptDesignPopupComponent } from 'src/app/popups/accept-design-popup/accept-design-popup.component'
import {  QuotationSummaryUploaded } from 'src/app/_Models/quotationNew/quotationNewsummary.model';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { RejectInvoicePopupComponent } from '../reject-Invoice-popup/reject-invoice-popup.component';
import { ViewInvoiceHistoryPopupComponent } from 'src/app/components/popups/view-invoice-history-popup/view-invoice-history-popup.component';
import { AcceptInvoiceDesignPopupComponent } from '../accept-invocie-popup/accept-invoice-design-popup.component';
import { Validator } from 'src/app/components/common/validator';
import { UserModel } from 'src/app/_Models/user/user.model';
import { JsonHelper } from 'src/app/components/common';
import { FileStoreService } from 'src/app/_Services/filestore/filestore.service';
import { AuthenticationService } from 'src/app/_Services/user/authentication.service';
import { FileContainerList, UserType } from 'src/app/components/common/static-data-common';
import { DocumentReuploadPopupComponent } from '../document-reupload-popup-quotation/document-reupload-popup.component';
import { InvoiceFileAttachmentData } from 'src/app/_Models/invoice/invoice-summary.model';
import { AttachmentFile } from 'src/app/_Models/fileupload/fileupload';
import { InvoiceSummaryService } from 'src/app/_Services/invoice/invoice-summary.service';
import { takeUntil } from 'rxjs';
import { DocumentInvoiceReuploadPopupComponent } from '../document-reupload-popup-invoice/document-invoice-reupload-popup.component';

@Component({
  selector: 'app-uploaded-invoice-doc-popup',
  templateUrl: './uploaded-invoice-doc-popup.component.html',
  styleUrls: ['./uploaded-invoice-doc-popup.component.scss']
})
export class UploadedInvoiceDocPopupComponent implements OnInit {
  @Input() data!: QuotationSummaryUploaded;
  @Output() refreshdata = new EventEmitter<any>();
  iframeUrl!: SafeResourceUrl;
  public _statuslist: any[] = [];
  public modelsReupload: InvoiceFileAttachmentData;
  public validatorReupload: Validator;
  public showLoader: boolean = false;
  public selectedQuotationForReupload: any = null;
  currentUser: UserModel;
  _IsCustomerUser: boolean = false;
  selectedComment: string = '';
  invoceiSU
  selectedApprovedComment: string = '';
  constructor(


     private modalService: NgbModal,
        private sanitizer: DomSanitizer,
        private toastr: ToastrService,
        private translate: TranslateService,
        private jsonHelper: JsonHelper,
        public validator: Validator,
        private fileService: FileStoreService,
        authserve: AuthenticationService,
      private invoiceService: InvoiceSummaryService,
        
  ) {

    this.currentUser = authserve.getCurrentUser();
        this._IsCustomerUser =
          this.currentUser.usertype == UserType.Customer ? true : false;
  }

  ngOnInit(): void {
    // Initialize iframe URL if data is available
    if (this.data && this.data.invoiceFileUrl) {
      this.setPdf(this.data.invoiceFileUrl);
    }
  }

  rejectPopup() {
    this.modalService.dismissAll();
    const modalRef = this.modalService.open(RejectInvoicePopupComponent, { windowClass: 'reject-popup-wrapper' });
    modalRef.componentInstance.data = this.data;
    modalRef.componentInstance.refreshdata.subscribe(() => {
      this.refreshdata.emit();
      this.modalService.dismissAll();
    });
  }

  acceptDesign() {
    this.modalService.dismissAll();
    const modalRef = this.modalService.open(AcceptInvoiceDesignPopupComponent, { centered: true, windowClass: 'accept-design-wrapper' });
    modalRef.componentInstance.data = this.data;
    modalRef.componentInstance.refreshdata.subscribe(() => {
      this.refreshdata.emit();
      this.modalService.dismissAll();
    });
  }

  closeModal() {
    this.modalService.dismissAll();
  }

  setPdf(url: string) {
    if (!url) {
      this.toastr.error(
        this.translate.instant('PDF URL is missing')
      );
      return;
    }
    const finalUrl = url + '#toolbar=0&navpanes=0&scrollbar=0';
    this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(finalUrl);
  }

  downloadFile(url?: string, filename?: string) {
    const downloadUrl = url || this.data?.invoiceFileUrl;

    if (!downloadUrl) {
      this.toastr.error(
        this.translate.instant('QUOTATIONNEW_SUMMARY.MSG_PDF_URL_MISSING') || 'File URL is missing'
      );
      return;
    }

    // Open in new tab for blob storage URLs (they have download capability built-in)
    window.open(downloadUrl, '_blank');

    this.toastr.success(
      this.translate.instant('QUOTATIONNEW_SUMMARY.MSG_DOWNLOAD_STARTED') || 'Download started'
    );
  }

  downloadQuotation(fileUrl: string) {
    // Create a hidden link element
    const link = document.createElement('a');

    link.href = fileUrl;                 // URL of the file
    link.download = 'Invoice.pdf'; // Name for the downloaded file
    link.target = '_blank';              // Optional, ensures it works in some browsers

    // Append, click, and remove
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }


  quotationHistory(quotationId: number) {
    const modalRef = this.modalService.open(ViewInvoiceHistoryPopupComponent, { centered: true, windowClass: 'history-view-wrapper' });
    modalRef.componentInstance.quotationId = quotationId;
  }




  
    triggerReuploadFileInput(fileInput: HTMLInputElement, quotationItem: any) {
      this.validator.isSubmitted = false;
      if (!this.validatorReupload) {
        this.loadReuploadValidator();
      }
      this.validatorReupload.initTost();
      this.validatorReupload.isSubmitted = true;
      fileInput.click();
    }
  
    onFileSelectedForReupload(event: Event, quotationItem: any) {
      // Initialize FileData if not already done
      if (!this.modelsReupload) {
        this.modelsReupload = new InvoiceFileAttachmentData();
      }
  
      this.modelsReupload.FileData = new AttachmentFile();
  
      const input = event.target as HTMLInputElement;
      const sampleFileSize = 10485760; // 10MB
      if (input.files && input.files.length > 0) {
        const file = input.files[0];
  
        if (file.size > sampleFileSize) {
  
          this.toastr.error(
            this.translate.instant('QUOTATIONNEW_SUMMARY.MSG_FILE_TOO_LARGE')
          );
          this.showError(
            "QUOTATIONNEW_SUMMARY.ERROR",
            "QUOTATIONNEW_SUMMARY.MSG_FILE_TOO_LARGE"
          );
          input.value = "";
          this.modelsReupload.FileData = new AttachmentFile();
          return;
        }
  
        if (!file.type.match("application/pdf*")) {
          this.showError(
            "QUOTATIONNEW_SUMMARY.ERROR",
            "QUOTATIONNEW_SUMMARY.MSG_INVALID_FILE_TYPE"
          );
          this.modelsReupload.FileData = new AttachmentFile();
          input.value = "";
          return;
        }
        var guid = this.newUniqueId();
        this.modelsReupload.FileData.fileName = file.name;
        this.modelsReupload.FileData.fileUrl = URL.createObjectURL(file);
        this.modelsReupload.FileData.file = file;
        this.modelsReupload.FileData.uniqueld = guid;
        input.value = "";
      }
  
  
  
      if (this.modelsReupload.FileData != null) {
        this.uploadReuploadFileToCloud(this.data)
        input.value = "";
      }
  
      // Reset the input value to allow re-uploading the same file
      input.value = "";
    }
  
    newUniqueId() {
      return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    }
  
  
    loadReuploadValidator() {
      this.validatorReupload = Validator.getValidator(
        this.modelsReupload,
        "lab-Report/lab-certificate.valid.json",
        this.jsonHelper,
        false,
        this.toastr,
        this.translate
      );
      this.validatorReupload.isSubmitted = false;
    }
  
    uploadReuploadFileToCloud(quotationItem: any) {
      if (this.isReuploadFormValid()) {
        this.showLoader = true;
        this.modelsReupload.showUploadBtnLoader = true;
        const fileItemsArray: Array<AttachmentFile> = [this.modelsReupload.FileData];
  
        this.fileService.uploadFiles(FileContainerList.Quotation, fileItemsArray).subscribe(
          (response) => {
            if (response && response.fileUploadDataList) {
              this.modelsReupload.FileData.fileUrl = response.fileUploadDataList[0].fileCloudUri;
              this.showLoader = false;
              this.showSuccess(
                "COMMON.LBL_FILE_UPLOAD",
                "COMMON.LBL_UPLOAD_MSG_SUC"
              );
  
              this.openReuploadQuotationPopup(this.modelsReupload.FileData, quotationItem);
              this.modelsReupload.FileData = new AttachmentFile();
            }
          },
          (error) => {
            this.showLoader = false;
            this.modelsReupload = new InvoiceFileAttachmentData();
            this.showError(
              "EDIT_CUSTOMER_PRODUCT.MSG_UPLOAD_FILE",
              "EDIT_CUSTOMER_PRODUCT.MSG_UNKNOWN_ERROR"
            );
          }
        );
      }
    }
  
  
    isReuploadFormValid() {
      return this.modelsReupload.FileData.fileName && this.modelsReupload.FileData.fileUrl;
    }
  
  
  


       openReuploadQuotationPopup(uploadedFile: AttachmentFile, quotationItem: any) {
            // Show loader while fetching quotation details
            this.showLoader = true;
    
            // Fetch quotation details from database
            this.invoiceService.getInvoiceDetails(quotationItem.id)
                .pipe()
                .subscribe(
                    (response) => {
                        this.showLoader = false;
    
                        if (response && response.result === 1) {
                            const invoiceDetails = response.data;
    
                            // Open the popup with fetched data
                            const modalRef = this.modalService.open(DocumentInvoiceReuploadPopupComponent, {
                                centered: true,
                                windowClass: 'doc-upload-popup-wrapper'
                            });
    
                            // Pass data to the popup
                            modalRef.componentInstance.invoiceId = invoiceDetails.invoiceId;
                            modalRef.componentInstance.invoiceData = invoiceDetails;
                            modalRef.componentInstance.fileData = uploadedFile;
                            modalRef.componentInstance.existingSupportingDocuments = invoiceDetails.supportingDocuments || [];
    
                            // Listen for popup close
                            modalRef.closed.subscribe((result) => {
                                if (result?.success) {
                                    // Refresh the uploaded quotations list after successful reupload
                                    // this.SearchUploadedDetails();
                                    this.selectedQuotationForReupload = null;
                                }
                            });
                        } else {
                            this.showError(
                                "INVOICE_SUMMARY.ERROR",
                                "INVOICE_SUMMARY.MSG_FETCH_QUOTATION_ERROR"
                            );
                        }
                    },
                    (error) => {
                        this.showLoader = false;
                        this.showError(
                            "INVOICE_SUMMARY.ERROR",
                            "INVOICE_SUMMARY.MSG_FETCH_QUOTATION_ERROR"
                        );
                        console.error('Error fetching quotation details:', error);
                    }
                );
        }
    
    componentDestroyed$(componentDestroyed$: any): any {
      throw new Error('Method not implemented.');
    }
  
  
    public showSuccess(title: string, msg: string, _disableTimeOut?: boolean) {
      let tradTitle: string = "";
      let tradMessage: string = "";
  
      this.translate.get(title).subscribe((text: string) => { tradTitle = text });
      this.translate.get(msg).subscribe((text: string) => { tradMessage = text });
  
      this.toastr.success(tradMessage, tradTitle, { disableTimeOut: _disableTimeOut });
    }
  
    public showError(title: string, msg: string, _disableTimeOut?: boolean) {
      let tradTitle: string = "";
      let tradMessage: string = "";
  
      this.translate.get(title).subscribe((text: string) => { tradTitle = text });
      this.translate.get(msg).subscribe((text: string) => { tradMessage = text });
  
      this.toastr.error(tradMessage, tradTitle, { disableTimeOut: _disableTimeOut });
    }
    public showWarning(title: string, msg: string, _disableTimeOut?: boolean) {
      let tradTitle: string = "";
      let tradMessage: string = "";
  
      this.translate.get(title).subscribe((text: string) => { tradTitle = text });
      this.translate.get(msg).subscribe((text: string) => { tradMessage = text });
  
      this.toastr.warning(tradMessage, tradTitle, { disableTimeOut: _disableTimeOut });
    }
  
}
